import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FilterService } from 'src/app/services/filter.service';

@Injectable({
  providedIn: 'root'
})
export class CommentsNotesService {

  constructor(
    private apiService: ApiService,
    private filterService: FilterService,
    private dashboardService: DashboardService
  ) {
  }
  
  postdata: any = {  
    "api_key": '100132', 
    "comment_typ": null,
  };
  
  modalData:any = {
    "U": [],
    "D": []
  }

  moveToFirst(data:any, key: string, value: string | number): void {
    const index = _.findIndex(data, (item:any) => item[key] == value);
    if (index > -1) {
      const [target] = _.pullAt(data, index);
      let updatedData:any = [target, ...data];
      return updatedData;
    } else {
      return data;
    }
  }

  groupMessagesByOutlookFormat(messageData: any, order: 'asc' | 'desc') {
    const now = new Date();
    // debugger
    // Calculate start times for each group
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfYesterday = new Date(startOfToday).setDate(new Date(startOfToday).getDate() - 1);
    const startOfThisWeek = new Date(startOfToday).setDate(new Date(startOfToday).getDate() - now.getDay());
    const startOfLastWeek = new Date(startOfThisWeek).setDate(new Date(startOfThisWeek).getDate() - 7);
    const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
    
    // Define group configurations with dynamic start and end times
    const groupDefinitions = [
      { name: 'Today', start: startOfToday, end: Infinity },
      { name: 'Yesterday', start: startOfYesterday, end: startOfToday },
      { name: 'This Week', start: startOfThisWeek, end: startOfYesterday },
      { name: 'Last Week', start: startOfLastWeek, end: startOfThisWeek },
      { name: 'This Month', start: startOfThisMonth, end: startOfLastWeek },
      { name: 'Last Month', start: startOfLastMonth, end: startOfThisMonth },
      { name: 'Older', start: -Infinity, end: startOfLastMonth },
    ];
    
    if(order == 'asc') {
      groupDefinitions.reverse();
    }


    // Initialize groups with empty messages
    const groupedMessages = groupDefinitions.map(g => ({
      group: g.name,
      messages: [],
    }));
    
    // Sort messages in descending order (latest first)
    const sortedMessages = _.orderBy(messageData, [(message) => new Date(message.insert_timestamp)], [order]);
    
    // Assign each message to the appropriate group
    sortedMessages.forEach((message) => {
      const messageDate = new Date(message.insert_timestamp).getTime();
      for (const groupDef of groupDefinitions) {
        if (messageDate >= groupDef.start && messageDate < groupDef.end) {
          const targetGroup:any = groupedMessages.find(g => g.group == groupDef.name);
          if (targetGroup) {
            targetGroup.messages.push(message);
          }
          break;
        }
      }
    });
    
    // Sort messages within each group (descending by default)
    return groupedMessages.map((group) => ({
      ...group,
      messages: _.orderBy(group.messages, [(message:any) => new Date(message.insert_timestamp)], [order]),
    }));
  }

  notesQuery(data: any) {
    
    let query = Object.assign({}, this.postdata, data);
    query['brand_key'] = this.filterService.baseQuery?.brand_key;
    query['module_key'] = this.dashboardService.moduleKey
    query['time_cycle'] = this.filterService.time_cycle || 'D';


    if(sessionStorage.getItem("brandKeyForFilters")) {
      let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
      let brand_key = JSON.parse(brandKey);
      query['brand_key'] = brand_key;
    }

    if(sessionStorage.getItem("tbl_name_suffix")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix");
      json = JSON.parse(json);
      query['tbl_name_suffix'] = json.tbl_name_suffix;
    }
    
    if(!query['brand_key']) return new Observable((ob) => ob.next(undefined));
    return this.apiService.post("api/notes/notes-data", query);
  }

  filterByKey(data:any, configuration:any) {
    if(!data.length) return [];
    let config = configuration.config;
    return data.filter((f:any)=> f[config?.groupKey] == configuration.key);
  }
}
